<template lang="pug">
  .content
    .shade
      el-form.form(ref="form", :model="form", :rules="rules")
        el-form-item(prop="userName")
          el-input(v-model="form.userName" placeholder="账号" clearable)
        el-form-item(prop="password")
          el-input(
            v-model="form.password"
            placeholder="密码"
            type="password"
            clearable
            @keyup.native.enter="login"
          )
        el-button.submit(
          :loading="loginLoading"
          :disabled="!form.userName || !form.password"
          type="primary"
          @click="login"
        ) 登&nbsp;&nbsp;录
</template>

<script>
import { userLogin, getLoginUserInfo } from '@/api/user';
import { setUserInfo, getToken } from '@/utils/auth';

export default {
  name: 'Login',
  data() {
    return {
      form: {
        userName: '',
        password: ''
      },
      rules: {
        userName: [
          { required: true, message: '请输入账号', trigger: 'no' }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'no' }
        ]
      },
      loginLoading: false
    };
  },
  methods: {
    async login() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const res = await userLogin(this.form);
          if (res.status === 1) this.$message.success('登录成功!');
          const token = getToken();
          const userInfo = await getLoginUserInfo();

          setUserInfo(token, userInfo.data);
          this.$router.push('/dashboard');
        }
      });
    }
  }
};
</script>

<style lang="less" scoped>
.form{
  & /deep/ .el-input__inner{
    background-color: #fff;
    border: 1px solid #dcdfe6;
    color: #606266;
  }
  & /deep/ .el-input__inner:focus{
    border-color: #409EFF;
  }
  & /deep/ .el-button--primary.is-disabled{
    color: #fff;
    background-color: #a0cfff;
    border-color: #a0cfff;
  }
  & /deep/ .el-button--primary.is-disabled:hover{
    background: #66b1ff;
    border-color: #66b1ff;
    color: #fff;
  }
  & /deep/ .el-button--primary:hover, .el-button--primary:focus{
    background: #66b1ff;
    border-color: #66b1ff;
    color: #fff;
  }
}

</style>

<style scope>
.content{
  width: 100vw;
  height: 100vh;
  background-image: url('../../assets/wallpaper_login.jpg');
  background-size: cover;
}
.shade{
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: hidden;
  background: rgba(25, 37, 63, 0.6);
}
.form{
  width: 240px;
  margin: 0 auto;
  padding: 30px;
  border-radius: 10px;
  background: #7cacde69;
}
.submit{
  width: 100%;
  margin-top: 20px
}
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue?257e5e11